module.exports = __webpack_public_path__ + "img/15.66ca9219.png";